import Vue from "vue";
import moment from "moment";
import router from "../router";
import store from "../store";
import axios from "axios";
import screenfull from "screenfull";
import cos from "./cos";
// Vue.prototype.$router = router

// new Vue({
//     router,
//     store,
//     render: h => h(App)
// })

const vueObject = new Vue({
  store,
  router
});
export default {
  // 只允许选今天及以前
  disabledDateOne(time) {
    return time.getTime() > Date.now();
  },

  /**
   * 获取食堂信息
   * @param {carte}
   */
  async getCanteenInfo() {
    var newParamData = {
      schoolId: vueObject.$store.state.schoolId
    };
    let res = await vueObject.$Http.getCanteenData(newParamData, true);
    if (res.code == 200 && res.data.length >= 1) {
      var valueData = res.data[0];
      sessionStorage.setItem("schoolCanteenId", valueData.id);
      sessionStorage.setItem("schoolCanteenInfo", JSON.stringify(valueData));
      // vueObject.$store.commit("UpdateCanteenId", valueData.id);
      // console.log(sessionStorage.getItem('schoolCanteenId') )
      return valueData;
    } else if (res.code == 101) {
    } else {
      return false;
    }
  },

  /**
   * 获取服务器时间
   */
   async getServerTime() {
    // let req = {
    //   schoolId: vueObject.$store.state.schoolId
    // };
    let res = await vueObject.$Http.getServerTime();
    if (res.code == 200) {
      let serverTime = res.data;
      sessionStorage.setItem("serverTime", serverTime);
      let localTime1 = parseInt(Date.parse(new Date()) / 1000);
      sessionStorage.setItem("localTime1", localTime1);
    } else {
      console.log("获取服务器时间错误");
    }
  },

  /**
   * 查看未读通知消息数量(num = 1 时为学校未读，为2时为教育局未读消息)
   */
  async getNoticesNumber(num = 1) {
    let req;
    if (num == 1) {
      req = {
        recipientId: vueObject.$store.getters.getUserInfo.schoolId
      }
    } else {
      req = {
        recipientId: vueObject.$store.getters.getUserInfo.eduId
      }
    }
    let res = await vueObject.$Http.getNoticesNumber(req);
    if (res.code == 200) {
      // vueObject.$store.commit("unreadMessages", res.data || 0);
      if (num == 1) {
        vueObject.$store.commit("unreadMessages", res.data || 0);
      } else {
        vueObject.$store.commit("unreadMessagesEdu", res.data || 0);
        
      }
    } else {
      
      if (num == 1) {
        vueObject.$store.commit("unreadMessages", 0);
      } else {
        vueObject.$store.commit("unreadMessagesEdu", 0);
      }
    }
  },
    /**
   * 修改消息状态(num = 1 时为学校，为2时为教育局)
   */
    async updateNoticesStatus(id, num = 1) {
      let req = {
        notificationNodeId: id
      };
      let res = await vueObject.$Http.updateNoticesStatus(req, true);
      if (res.code == 200) {
        if (num == 1) {
          this.getNoticesNumber(1);
        } else {
          this.getNoticesNumber(2);
          
        }
      } else {
        console.log(res)
      }
    },

  /**
   * 获取图片信息
   * @param {carte}
   */
  getImgInfo(imgPath) {
    var imgWebUrl = vueObject.$store.state.config.fileUrl + imgPath;
    var img = new Image();
    img.onload = function() {
      if (!hasFinish) {
        // flag = true;
        // hasFinish = true;
        console.log("Ping " + imgPath + " success. ");
        // alert("成功"+imgPath);
      }
    };
    img.onerror = function() {
      if (!hasFinish) {
        if (!isCloseWifi) {
          // flag = true;
          console.log("Ping " + imgPath + " success. ");
          // alert("成功"+imgPath);
        } else {
          console.log("network is not working!");
        }
        hasFinish = true;
      }
    };
    // let instance = axios.create({
    //     baseURL:vueObject.$store.state.config.fileUrl+imgPath,
    //     // baseURL:'http://192.168.1.115:8083/shuangan',
    //     // baseURL:'http://192.168.1.116:8083/shuangan',
    //     timeout:10000,
    // })
    // var newParamData = {}
    // try{
    //     response = await instance['get'](imgWebUrl,'',{
    //         Accept:''
    //     })
    // }catch(err){
    //     response = err
    // }
    // let res = await  vueObject.$Http.getCanteenData(newParamData)
    // if(res.code == 200 && res.data.length>=1){
    //     var valueData = res.data[0]
    //     sessionStorage.setItem('schoolCanteenId',valueData.id)
    //     sessionStorage.setItem('schoolCanteenInfo',JSON.stringify(valueData))
    //     console.log(sessionStorage.getItem('schoolCanteenId') )
    //     return valueData;
    // }else{
    //     return false;
    // }
  },

  /**
   * 根据日期计算年龄
   * @param timeStamp  13位的时间戳
   */
  calculationAges(timeStamp) {
    var dateStr = this.timeStampToDate(timeStamp);
    var r = dateStr.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/);
    if (r == null) return false;
    var d = new Date(r[1], r[3] - 1, r[4]);
    if (
      d.getFullYear() == r[1] &&
      d.getMonth() + 1 == r[3] &&
      d.getDate() == r[4]
    ) {
      var Y = new Date().getFullYear();
      return Y - r[1];
    }
    return 0;
  },

  /**
   * 退出登录
   */
  loginOut() {
    // sessionStorage.setItem('schoolInfo',false)
    // sessionStorage.setItem('userInfo',false)
    // sessionStorage.setItem('schoolId','')

    vueObject.$router.replace("/login");
    setTimeout(() => {
      window.location.reload();
      sessionStorage.clear();
    }, 50);
  },

  /**
   * 页面跳转
   * @param {string} topath 要跳转的页面
   * @param {number} pagePosition   页面级别位置
   * @param {number 0 /1 } jumpMode 是否要新建页面
   */
  pageJump(topath, pagePosition = "", jumpMode = 0) {
    // console.log(submenu)
    console.log(topath,jumpMode)
    if (jumpMode == 1) {
      // window.open(topath, '_blank','width=1920,height=1080,menubar=no,toolbar=no,status=no,scrollbars=yes');
      window.open(
        topath,
        "_blank",
        "width=1440,height=1080,menubar=no,toolbar=no,status=no,scrollbars=yes"
      );
      // window.open(topath);

      return false;
    }
    // console.log(vueObject.$router)
    if (topath == vueObject.$route.path) {
      // console.log(vueObject.$router)
      // vueObject.$router.push(topath);

      // vueObject.$router.go(0);
      return false;
      // window.location.reload()
    }

    if (topath == "") {
      return false;
      // window.location.reload()
    }

    switch (pagePosition) {
      case "":
        sessionStorage.setItem("thisOnePagePath", topath);
        sessionStorage.setItem("thisLeftPagePath", topath);
        sessionStorage.setItem("thisTopPagePath", topath);
        vueObject.$store.commit("updateMenuListKeyOne", 0);
        vueObject.$store.commit("updateMenuListKeyTwo", 0);
        break;
      // 一级菜单
      case 1:
        sessionStorage.setItem("thisOnePagePath", topath);
        vueObject.$store.commit("updateMenuListKeyOne", 0);
        vueObject.$store.commit("updateMenuListKeyTwo", 0);
        break;
      // 二级菜单
      case 2:
        sessionStorage.setItem("thisLeftPagePath", topath);
        sessionStorage.setItem("thisTopPagePath", topath);
        break;
      // 三级菜单
      case 3:
        sessionStorage.setItem("thisTopPagePath", topath);
        break;
      // 校园态势里边的导航记录
      case 10:
        sessionStorage.setItem("thisSituationPagePath", topath);
        break;
    }

    sessionStorage.setItem("thisPagePath", topath);
    vueObject.$router.push(topath);
  },

  checkImgExists(imgurl) {
    var ImgObj = new Image(); //判断图片是否存在
    var webImgUrl = vueObject.$store.state.config.fileUrl + imgurl;
    ImgObj.src = webImgUrl;
    //没有图片，则返回-1
    if (ImgObj.fileSize > 0 || (ImgObj.width > 0 && ImgObj.height > 0)) {
      return ImgObj.src;
    } else {
      return "/img/no_img.png";
    }
  },

  validateImage(url) {
    // var xmlHttp ;
    var webImgUrl = vueObject.$store.state.config.fileUrl + url;
    // var oreq = new ActiveXObject("Microsoft.XMLHTTP")
    // oreq.open("Get",webImgUrl,false);
    // oreq.send();
    // alert(oReq.status)
    // if(oReq.status==404)
    // return '/img/no_img.png';
    // else
    // return webImgUrl;

    var iXHR = new XMLHttpRequest();
    iXHR.open("HEAD", webImgUrl, true);
    iXHR.send();
    iXHR.onreadystatechange = function() {
      if (iXHR.readyState === 4 && iXHR.status === 200) {
        // appendHtml(JSON.parse(iXHR.responseText));
      }
      console.log(iXHR);
      // if (iXHR.readystate != 4)  return;

      // var iLength = iXHR.getResponseHeader('Content-Length'),
      //     iType = iXHR.getResponseHeader('Content-Type');

      // if (iLength > 0)
      //     iCallback.call(iXHR, iType, iLength);
    };
  },

  //保存参数的页面跳转
  paramPageJump(dataName = "", dataInfo = "", path) {
    if (dataName != "") {
      sessionStorage.setItem(dataName, JSON.stringify(dataInfo));
    }
    this.pageJump(path, 0);
  },

  // 获取当前页面的Url
  getThisPage() {
    return sessionStorage.getItem("thisPagePath");
  },

  // 获取当前页面第一级的Url
  getThisOnePage() {
    return sessionStorage.getItem("thisOnePagePath");
  },

  // 获取当前页面左边的Url
  getThisLeftPage() {
    return sessionStorage.getItem("thisLeftPagePath");
  },

  // 获取当前页面上边的Url
  getThisTopPage() {
    return sessionStorage.getItem("thisTopPagePath");
  },

  // 获取当前校园态势页面上边的Url
  getThisSituationPage() {
    return sessionStorage.getItem("thisSituationPagePath");
  },

  // unix（10位的）时间戳转换 年月日
  dateFormatDate(thisTime) {
    return moment.unix(thisTime).format("YYYY-MM-DD");
  },

  // unix（10位的）时间戳转换 年月日时分秒
  dateFormatDateTwo(thisTime) {
    return moment.unix(thisTime).format("YYYY-MM-DD HH:mm:ss");
  },

  // unix（10位的）时间戳转换 年月日时分
  dateFormatDateThree(thisTime) {
    return moment.unix(thisTime).format("YYYY-MM-DD HH:mm");
  },

  // js（13位的）时间戳转换 年月日
  timeStampToDate(thisTime) {
    return moment(thisTime).format("YYYY-MM-DD");
  },

  // 公共函数库

  /**
   * 将以base64的图片url数据转换为Blob
   * @param urlData
   * 用url方式表示的base64图片数据
   */

  convertBase64UrlToBlob(urlData) {
    var bytes = window.atob(urlData.split(",")[1]); //去掉url的头，并转换为byte

    //处理异常,将ascii码小于0的转换为大于0
    var ab = new ArrayBuffer(bytes.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < bytes.length; i++) {
      ia[i] = bytes.charCodeAt(i);
    }

    return new Blob([ab], { type: "image/png" });
  },

  base64ToFile(urlData, fileName) {
    let arr = urlData.split(",");
    let mime = arr[0].match(/:(.*?);/)[1];
    let bytes = atob(arr[1]); // 解码base64
    let n = bytes.length;
    let ia = new Uint8Array(n);
    while (n--) {
      ia[n] = bytes.charCodeAt(n);
    }
    return new File([ia], fileName, { type: mime });
  },
  /**
   * @param limit 大小长度B字节
   */
  fileSizeString(limit) {
    var size = "";
    if (limit < 0.1 * 1024) {
      //小于0.1KB，则转化成B
      size = limit.toFixed(2) + "B";
    } else if (limit < 0.1 * 1024 * 1024) {
      //小于0.1MB，则转化成KB
      size = (limit / 1024).toFixed(2) + "KB";
    } else if (limit < 0.1 * 1024 * 1024 * 1024) {
      //小于0.1GB，则转化成MB
      size = (limit / (1024 * 1024)).toFixed(2) + "MB";
    } else {
      //其他转化成GB
      size = (limit / (1024 * 1024 * 1024)).toFixed(2) + "GB";
    }

    var sizeStr = size + ""; //转成字符串
    var index = sizeStr.indexOf("."); //获取小数点处的索引
    var dou = sizeStr.substr(index + 1, 2); //获取小数点后两位的值
    if (dou == "00") {
      //判断后两位是否为00，如果是则删除00
      return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);
    }
    return size;
  },
  /**
   * 获取文件名称
   * @param {fileUrl}   文件Url
   */
  getFileName(fileUrl) {
    var index = fileUrl.lastIndexOf("/");
    var fileName = fileUrl.substring(index + 1, fileUrl.length);
    return fileName;
  },

  /**
   *
   * @param {*} event  上传对象
   * @param {*} fileUploadType 上传类型1 file上传,2base64上传
   */
  async fileUpload(event, fileUploadType = 1) {
    if (fileUploadType == 1) {
      if (event.target.files.length <= 0) {
        return false;
      }
      var fileUpload = event.target.files[0];
    } else {
      var fileUpload = event;
    }

    // console.log(fileUpload)

    var requestData = {
      file: fileUpload
    };
    const loading = vueObject.$loading({
      lock: true,
      text: "文件上传中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });
    let res = await vueObject.$Http.oneFileUpload(requestData, true);
    if (res.code == 200) {
      vueObject.$message({
        type: "success",
        message: "文件上传成功"
      });
      loading.close();
      // console.log(res)
      var newFileInfo = {};
      for (var testData in res.data) {
        newFileInfo = {
          fileName: testData,
          fileUrl: res.data[testData],
          fileSize: fileUpload.size
        };
      }
      return newFileInfo;
    } else if (res.code == 101) {
    } else {
      loading.close();
      vueObject.$message({
        type: "error",
        message: res.messsage
      });
    }
  },
  /**
   *
   * @param {*} event  上传对象
   * @param {*} fileUploadType 上传类型1 file上传,2base64上传
   */
  async fileUploadNew(event, fileUploadType = 1) {
    if (fileUploadType == 1) {
      var fileUpload = event.file;
    } else {
      var fileUpload = event;
    }
    // console.log(fileUpload)
    let req = {
      file: fileUpload
    };
    const loading = vueObject.$loading({
      lock: true,
      text: "文件上传中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });
    let res = await vueObject.$Http.oneFileUpload(req, true);
    loading.close();
    // console.log(res)
    if (res.code == 200) {
      vueObject.$message({
        type: "success",
        message: "文件上传成功"
      });
      let newFileInfo = {};
      for (var testData in res.data) {
        newFileInfo = {
          fileName: testData,
          fileUrl: res.data[testData],
          fileSize: fileUpload.size
        };
      }
      return newFileInfo;
    } else if (res.code == 101) {
    } else {
      vueObject.$message({
        type: "error",
        message: res.messsage
      });
    }
  },
  /**
   *
   * @param {*} event  上传对象
   * @param {*} fileUploadType 上传类型1 file上传,2base64上传
   */
  async fileUploadTencent(event, fileUploadType = 1) {
    if (fileUploadType == 1) {
      var fileUpload = event.file;
    } else {
      var fileUpload = event;
    }
    // console.log(fileUpload)
    let req = {
      file: fileUpload
    };
    const loading = vueObject.$loading({
      lock: true,
      text: "文件上传中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });
    let res = await vueObject.$httpUpload.uploadFileTencent(req, true);
    loading.close();
    console.log(res)
    return res;
  },

  async uploadFileHxg(event, fileUploadType = 1) {
    if (fileUploadType == 1) {
      var fileUpload = event.file;
    } else {
      var fileUpload = event;
    }
    console.log(event)

    // console.log(fileUpload)
    // let req = {
    //   file: fileUpload,
    //   eduId:data.eduId
    // };
    const loading = vueObject.$loading({
      lock: true,
      text: "文件上传中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });
    console.log(event)
    let res = await vueObject.$httpUpload.uploadFileHxg(event);
    // let res = await vueObject.$Http.uploadFileHxg(event);
    loading.close();
    console.log(res)
    return res;
  },
  
  guid() {
    return "xxxxxxxxxxxxxxxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  },
  // 截取字符串中匹配的最后一个字符（默认为“.”）及点后边字符（num为0包含匹配的字符，为1则不包含）
  stringSlice(str, type = ".", num = 0){
    let dotIndex = str.lastIndexOf(type);  
    // console.log(dotIndex,666)
    if (dotIndex > 0) {  
      let lastPart = str.slice(dotIndex + num);  
      // console.log(lastPart);
      return lastPart;
    } else {
      return "";
    }
  },

  /**
   *
   * @param {*} event  上传对象
   * @param {*} fileUploadType 上传类型1 file上传,2base64上传
   */
  async fileUploadCos(file, fileUploadType = 1) {
    const loading = vueObject.$loading({
      lock: true,
      text: "文件上传中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });
    let fileName = this.guid() + this.stringSlice(file.name);
    // console.log(fileName,555)
    try {
      var data = await cos.putObject(
        { 
          SecretId: 'AKID5uCLUL3HNhkV2RnBWaN2dAyjFVeap2Ye',
          SecretKey: '6vTJXYEi4D69uPi1Al6BxUJzLPPSErBF',
          Bucket: 'tptas-1303877339', /* 填写自己的 bucket，必须字段 */
          Region: 'ap-beijing',     /* 存储桶所在地域，必须字段 */
          Key: fileName,              /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
          Body: file, // 上传文件对象
          // 可选配置项
          FileParallelLimit: 5, // 并行上传文件的个数，默认值是 3
          ChunkParallelLimit: 10, // 并行上传分片的个数，默认值是 3
          SliceSize: 1024 * 1024 * 20,     /* 触发分块上传的阈值，超过20MB 使用分块上传，小于20MB使用简单上传。可自行设置，非必须 */  
        });
      loading.close();
      return { err: null, data: data };
    } catch (err) {
      loading.close();
      console.log(err)
      return { err: err, data: null };
    }
  },
   /**
   *
   * @param {*} event  上传对象 分片上传
   * @param {*} fileUploadType 上传类型1 file上传,2base64上传
   */
   async fileUploadCosGrid(file, fileUploadType = 1) {
    const loading = vueObject.$loading({
      lock: true,
      text: "文件上传中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.1)"
    });
    let fileName = this.guid() + this.stringSlice(file.name);
    // console.log(fileName,555) uploadFile
    try { 
      var data = await cos.uploadFile(
        { 
          SecretId: 'AKID5uCLUL3HNhkV2RnBWaN2dAyjFVeap2Ye',
          SecretKey: '6vTJXYEi4D69uPi1Al6BxUJzLPPSErBF',
          Bucket: 'tptas-1303877339', /* 填写自己的 bucket，必须字段 */
          Region: 'ap-beijing',     /* 存储桶所在地域，必须字段 */
          Key: fileName,              /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
          Body: file, // 上传文件对象
          // 可选配置项
          FileParallelLimit: 5, // 并行上传文件的个数，默认值是 3
          ChunkParallelLimit: 10, // 并行上传分片的个数，默认值是 3
          SliceSize: 1024 * 1024 * 5,     /* 触发分块上传的阈值，超过20MB 使用分块上传，小于20MB使用简单上传。可自行设置，非必须 */  
          onProgress: function (progressData) {
            console.log(progressData);
            loading.setText("文件上传中..."+progressData.percent*100+'%');

          }
          
        });
      loading.close();
      return { err: null, data: data };
    } catch (err) {
      loading.close();
      console.log(err)
      return { err: err, data: null };
    }
  },
  
  // 腾讯接口下载
  downloadCos(fileUrl,name) {
    let keyName = this.stringSlice(fileUrl, "/", 1);
    // console.log(keyName)
    const loading = vueObject.$loading({
      lock: true,
      text: "下载中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });
    cos.getObject({
        Bucket: 'tptas-1303877339', /* 填写自己的 bucket，必须字段 */
        Region: 'ap-beijing',     /* 存储桶所在地域，必须字段 */
        Key: keyName,        /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
        DataType: 'blob', 
        // onProgress: function (progressData) {
        //     console.log(JSON.stringify(progressData));
        // }
    }, (err, data) => {
      loading.close();
      if (err) {
        console.log(err);
      } else {
        const content = data.Body;
        const blob = new Blob([content]); // 构造一个blob对象来处理数据
        // const fileName = newFileName; // 导出文件名
        // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        // IE10以上支持blob但是依然不支持download
        const fileName = name + this.dateFormatDateTwo(Date.parse(new Date()) / 1000) + this.stringSlice(fileUrl);
        if ("download" in document.createElement("a")) {
          // 支持a标签download的浏览器
          const link = document.createElement("a"); // 创建a标签
          link.download = fileName; // a标签添加属性
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click(); // 执行下载
          URL.revokeObjectURL(link.href); // 释放url
          document.body.removeChild(link); // 释放标签
        } else {
          // 其他浏览器
          navigator.msSaveBlob(blob, fileName);
        }
      }
    });
  },

  // 删除图片
  async delFile(fileUrl) {
    let req = {
      fileName: fileUrl
    };
    let res = await vueObject.$Http.delFile(req, true);
    if (res.code == 200) {
      return true;
    } else {
      vueObject.$message({
        message: res.messsage,
        type: "error"
      });
      return false;
    }
  },

  // 文件下载
  async fileDownloads(filePath = "") {
    var requestData = {
      fileName: filePath
    };
    let res = await vueObject.$Http.fileDownload(requestData);
    console.log(res)
    var newFileName = requestData.fileName.split("/").pop();
    console.log(newFileName);

    const content = res;
    const blob = new Blob([content]); // 构造一个blob对象来处理数据
    const fileName = newFileName; // 导出文件名
    // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
    // IE10以上支持blob但是依然不支持download
    if ("download" in document.createElement("a")) {
      // 支持a标签download的浏览器
      const link = document.createElement("a"); // 创建a标签
      link.download = fileName; // a标签添加属性
      link.style.display = "none";
      link.href = URL.createObjectURL(blob);
      document.body.appendChild(link);
      link.click(); // 执行下载
      URL.revokeObjectURL(link.href); // 释放url
      document.body.removeChild(link); // 释放标签
    } else {
      // 其他浏览器
      navigator.msSaveBlob(blob, fileName);
    }
  },

  // 导出
  async exportData(req, apiFunction, name, isFormData = false, fileFormat = ".xls") {
    const loading = vueObject.$loading({
      lock: true,
      text: "导出数据中,请稍等...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });
    let res = await vueObject.$Http[apiFunction](req, isFormData);
    loading.close();
    const content = res;
    console.log('content',content)
    if(content.size <= 100){
      vueObject.$message('暂无数据');
      return;
    }
    const blob = new Blob([content]);
    // console.log(blob)
    const fileName =
      name + this.dateFormatDateTwo(Date.parse(new Date()) / 1000) + fileFormat; // 导出文件名
    // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
    // IE10以上支持blob但是依然不支持download
    if ("download" in document.createElement("a")) {
      // 支持a标签download的浏览器
      const link = document.createElement("a"); // 创建a标签
      link.download = fileName; // a标签添加属性
      link.style.display = "none";
      link.href = URL.createObjectURL(blob);
      document.body.appendChild(link);
      link.click(); // 执行下载
      URL.revokeObjectURL(link.href); // 释放url
      document.body.removeChild(link); // 释放标签
    } else {
      // 其他浏览器
      navigator.msSaveBlob(blob, fileName);
    }
  },

  // 在线预览
  viewFile(fileUrl) {
    let onlineViewType = ["doc", "docx", "xls", "xlsx", "xlsm", "ppt", "pptx"];
    let fileTypeName = fileUrl
      .substring(fileUrl.lastIndexOf(".") + 1, fileUrl.length)
      .split("?")[0];
    let isWord = onlineViewType.find((type) => type === fileTypeName);
    if (isWord) {
      var url = vueObject.$store.state.config.fileUrl + fileUrl;
      window.open(url, "_blank");
    }
  },

  // 获取全部隐患类型
  async getAllHiddenDangerType() {
    let req = {
      schoolId: vueObject.$store.state.schoolId
    };
    let res = await vueObject.$Http.getAllHiddenDangerType(req, true);
    if (res.code == 200) {
      let hiddenDangerType = res.data.map((element) => {
        return {
          id: element.hiddenDangerId,
          nameOne: element.hiddenDangerClassifyName,
          type: element.hiddenDangerClassifyOperation
        };
      });
      // console.log(hiddenDangerType);
      vueObject.$store.commit("updateHiddenDangerType", hiddenDangerType);
      return hiddenDangerType;
    } else {
      this.$message({
        message: res.messsage,
        type: "error"
      });
      return;
    }
  },

  //格式化数字
  formatDig(num) {
    return num > 9 ? "" + num : "0" + num;
  },

  //格式化日期
  formatDate(mill) {
    var y = new Date(mill);
    let raws = [
      y.getFullYear(),
      this.formatDig(y.getMonth() + 1),
      this.formatDig(y.getDate())
    ];
    let format = ["-", "-", ""];
    return String.raw({ raw: raws }, ...format);
  },

  // 获取学期
  createTerm(year, isInitDisable) {
    var termDays = [];
    var isDisableArr = [true, true];
    if (!isInitDisable) {
      var currentMonth = new Date().getMonth();
      var currentYear = new Date().getFullYear();
      isDisableArr = [false, false];
      if (year > currentYear) {
        isDisableArr = [false, false];
      } else if (year < currentYear) {
        isDisableArr = [true, true];
        if (
          parseInt(currentYear) - parseInt(year) === 1 &&
          (currentMonth == 0 || currentMonth == 1)
        ) {
          isDisableArr = [true, false];
        }
      } else {
        if (currentMonth > 9) {
          isDisableArr = [true, false];
        }
      }
    }

    var prefix = year;
    termDays.push({
      start: prefix + "-03-01",
      end: prefix + "-08-31",
      disable: isDisableArr[0],
      dateName: "上学期",
      dateRange: prefix + "-03-01" + "~" + prefix + "-08-31"
    });
    termDays.push({
      start: prefix + "-09-01",
      end: parseInt(prefix) + 1 + "-02-28",
      disable: isDisableArr[1],
      dateName: "下学期",
      dateRange: prefix + "-09-01" + "~" + (parseInt(prefix) + 1) + "-02-28"
    });
    return termDays;
  },

  // 获取季度 （已过的不能选择）
  createQuarter(year, isInitDisable) {
    var quarterDays = [];
    var isDisableArr = [true, true, true, true];

    if (!isInitDisable) {
      var currentMonth = new Date().getMonth();
      var currentYear = new Date().getFullYear();
      isDisableArr = [false, false, false, false];
      if (year > currentYear) {
        isDisableArr = [false, false, false, false];
      } else if (year < currentYear) {
        isDisableArr = [true, true, true, true];
      } else {
        if (currentMonth > 8) {
          isDisableArr = [true, true, true, false];
        } else if (currentMonth > 5) {
          isDisableArr = [true, true, false, false];
        } else if (currentMonth > 2) {
          isDisableArr = [true, false, false, false];
        }
      }
    }

    var prefix = year + "-";
    quarterDays.push({
      start: prefix + "01-01",
      end: prefix + "03-31",
      disable: isDisableArr[0],
      dateName: "第一季度",
      dateRange: prefix + "01-01" + "~" + prefix + "03-31"
    });
    quarterDays.push({
      start: prefix + "04-01",
      end: prefix + "06-30",
      disable: isDisableArr[1],
      dateName: "第二季度",
      dateRange: prefix + "04-01" + "~" + prefix + "06-30"
    });
    quarterDays.push({
      start: prefix + "07-01",
      end: prefix + "09-30",
      disable: isDisableArr[2],
      dateName: "第三季度",
      dateRange: prefix + "07-01" + "~" + prefix + "09-30"
    });
    quarterDays.push({
      start: prefix + "10-01",
      end: prefix + "12-31",
      disable: isDisableArr[3],
      dateName: "第四季度",
      dateRange: prefix + "10-01" + "~" + prefix + "12-31"
    });

    return quarterDays;
  },

  // 获取季度 (未到的不能选择)
  createQuarterTwo(year = "", isInitDisable) {
    if (year == "") {
      year = this.getThisYear();
    }
    var quarterDays = [];
    var isDisableArr = [true, true, true, true];

    if (!isInitDisable) {
      var currentMonth = new Date().getMonth();
      var currentYear = new Date().getFullYear();
      isDisableArr = [false, false, false, false];
      if (year > currentYear) {
        isDisableArr = [false, false, false, false];
      } else if (year < currentYear) {
        isDisableArr = [true, true, true, true];
      } else {
        if (currentMonth >= 10) {
          isDisableArr = [true, true, true, true];
        } else if (currentMonth >= 7) {
          isDisableArr = [true, true, true, false];
        } else if (currentMonth >= 4) {
          isDisableArr = [true, true, false, false];
        }
      }
      // console.log(isDisableArr)
    }

    var prefix = year + "-";
    quarterDays.push({
      start: prefix + "01-01",
      end: prefix + "03-31",
      startInt: new Date(prefix + "01-01").getTime(),
      endInt: new Date(prefix + "03-31").getTime(),
      disable: !isDisableArr[0],
      dateName: "第一季度",
      dateRange: prefix + "01-01" + "~" + prefix + "03-31",
      dateNumber: 1
    });
    quarterDays.push({
      start: prefix + "04-01",
      end: prefix + "06-30",
      startInt: new Date(prefix + "04-01").getTime(),
      endInt: new Date(prefix + "06-30").getTime(),
      disable: !isDisableArr[1],
      dateName: "第二季度",
      dateRange: prefix + "04-01" + "~" + prefix + "06-30",
      dateNumber: 2
    });
    quarterDays.push({
      start: prefix + "07-01",
      end: prefix + "09-30",
      startInt: new Date(prefix + "07-01").getTime(),
      endInt: new Date(prefix + "09-30").getTime(),
      disable: !isDisableArr[2],
      dateName: "第三季度",
      dateRange: prefix + "07-01" + "~" + prefix + "09-30",
      dateNumber: 3
    });
    quarterDays.push({
      start: prefix + "10-01",
      end: prefix + "12-31",
      startInt: new Date(prefix + "10-01").getTime(),
      endInt: new Date(prefix + "12-31").getTime(),
      disable: !isDisableArr[3],
      dateName: "第四季度",
      dateRange: prefix + "10-01" + "~" + prefix + "12-31",
      dateNumber: 4
    });

    return quarterDays;
  },

  // 获取月
  createMonths(year, isInitDisable) {
    var monthDays = [];
    var isDisable = true;
    for (var i = 0; i < 12; i++) {
      var thisMonthData = {};
      if (!isInitDisable) {
        var currentMonth = new Date().getMonth();
        var currentYear = new Date().getFullYear();
        if (year > currentYear) {
          isDisable = false;
        } else {
          if (i >= currentMonth && year == currentYear) {
            isDisable = false;
          }
        }
      }
      var prefix = year + "-" + this.formatDig(parseInt(i) + 1);
      var thisMonthNum = this.formatDig(parseInt(i) + 1);
      if (i == 0 || i == 2 || i == 4 || i == 6 || i == 7 || i == 9 || i == 11) {
        thisMonthData = {
          start: prefix + "-01",
          end: prefix + "-31",
          disable: isDisable,
          dateRange: prefix + "-01" + "~" + prefix + "-31",
          dateName: thisMonthNum + "月"
        };
        // monthDays.push({'start': prefix + '-01', 'end': prefix + '-31', 'disable': isDisable});
      } else if (i == 3 || i == 5 || i == 8 || i == 10) {
        thisMonthData = {
          start: prefix + "-01",
          end: prefix + "-30",
          disable: isDisable,
          dateRange: prefix + "-01" + "~" + prefix + "-30",
          dateName: thisMonthNum + "月"
        };
        // monthDays.push({'start': prefix + '-01', 'end': prefix + '-30', 'disable': isDisable});
      } else if (i == 1) {
        var cond1 = year % 4 == 0;
        var cond2 = year % 100 != 0;
        var cond3 = year % 400 == 0;
        var cond = (cond1 && cond2) || cond3;
        if (cond) {
          thisMonthData = {
            start: prefix + "-01",
            end: prefix + "-29",
            disable: isDisable,
            dateRange: prefix + "-01" + "~" + prefix + "-29",
            dateName: thisMonthNum + "月"
          };
          // monthDays.push({'start': prefix + '-01', 'end': prefix + '-29', 'disable': isDisable});
        } else {
          thisMonthData = {
            start: prefix + "-01",
            end: prefix + "-28",
            disable: isDisable,
            dateRange: prefix + "-01" + "~" + prefix + "-28",
            dateName: thisMonthNum + "月"
          };
          // monthDays.push({'start': prefix + '-01', 'end': prefix + '-28', 'disable': isDisable});
        }
      }

      monthDays.push(thisMonthData);
    }
    return monthDays;
  },

  // 获取星期
  *createWeeks(year) {
    const ONE_DAY = 24 * 3600 * 1000;
    let start = new Date(year, 0, 1),
      end = new Date(year, 11, 31);
    let firstDay = start.getDay() || 7,
      lastDay = end.getDay() || 7;
    let startTime = +start,
      endTime = startTime + (7 - firstDay) * ONE_DAY,
      _endTime = end - (7 - lastDay) * ONE_DAY;
    yield [startTime, endTime];
    startTime = endTime + ONE_DAY;
    endTime = endTime + 7 * ONE_DAY;
    while (endTime < _endTime) {
      yield [startTime, endTime];
      startTime = endTime + ONE_DAY;
      endTime = endTime + 7 * ONE_DAY;
    }
    yield [startTime, +end];
  },

  // 返回星期数据
  returnWeek(year) {
    var weekArray = [];
    let index = 1;
    let currentTime = Date.parse(new Date());
    for (let i of this.createWeeks(year)) {
      let start = i[0],
        end = i[1];
      let j = index++,
        isWeekDisable = false;
      //设置周是否禁用
      if (currentTime > end + 86400000) {
        isWeekDisable = true;
      }
      weekArray.push({
        week: this.formatDig(j),
        dateName: "第" + this.formatDig(j) + "周",
        start: this.formatDate(start),
        end: this.formatDate(end),
        disable: isWeekDisable,
        dateRange: this.formatDate(start) + "~" + this.formatDate(end),
        key: this.formatDate(end).substring(0, 5) + this.formatDig(j)
      });
    }

    return weekArray;
  },

  // 获取当前年份
  getThisYear() {
    var myDate = new Date();
    var tYear = myDate.getFullYear();
    return tYear;
  },

  // 获取一年的开始AND结束时间戳
  getYearTime(startTime) {
    var timeStamp = {
      startTime: startTime,
      endTime: moment(startTime)
        .endOf("year")
        .valueOf()
    };
    return timeStamp;
  },

  // 获取一个季度的开始AND结束时间戳
  getQuarterTime(startNumber) {
    var quarterTime = moment()
      .quarter(startNumber)
      .valueOf();
    var timeStamp = {
      startTime: moment(quarterTime)
        .startOf("quarter")
        .valueOf(),
      endTime: moment(quarterTime)
        .endOf("quarter")
        .valueOf()
    };
    return timeStamp;
  },

  // 获取一个月的开始AND结束时间戳
  getMonthTime(startTime) {
    var timeStamp = {
      startTime: startTime,
      endTime: moment(startTime)
        .endOf("month")
        .valueOf()
    };
    return timeStamp;
  },

  // 获取一个星期的开始AND结束时间戳
  getWeekTime(startTimes) {
    var timeStamp = {
      startTime: moment(startTimes).valueOf(),
      endTime: moment(startTimes)
        .endOf("week")
        .valueOf()
    };
    return timeStamp;
  },

  // 获取年季度月周时间戳
  getPartTimeStamp() {
    var timeStamp = {
      yearTime: moment().startOf("year"),
      monthTime: moment().startOf("month"),
      quarterTime: moment().quarter(),
      weekTime: moment().startOf("week")
    };
    return timeStamp;
  },
  // 校验手机号
  checkPhoneNumber(tel) {
    if (/^1[3456789]\d{9}$/.test(tel)) {
      return true;
    } else {
      return false;
    }
  },
  // 数据匹配（获取名称）
  getDataName(data, id) {
    let value = data.find((item, index) => {
      return item.id == id;
    });
    if (!value) {
      return "";
    } else {
      return value.nameOne || value.name || "";
    }
  },
  // 星期转换
  weekTransition(num) {
    switch (Number(num)) {
      case 1:
        return "星期一";
        break;
      case 2:
        return "星期二";
        break;
      case 3:
        return "星期三";
        break;
      case 4:
        return "星期四";
        break;
      case 5:
        return "星期五";
        break;
      case 6:
        return "星期六";
        break;
      case 7:
        return "星期日";
        break;
    }
  },
  // 文件预览
  filePreview(url) {
    if (!url) {
      vueObject.$message({
        message: "当前文件为空，请联系管理员",
        type: "warning"
      });
    } else {
      let filePath = vueObject.$store.state.config.fileUrl + url;
      let urlSuffix = url.split(".").pop();
      if (
        urlSuffix == "pdf" ||
        urlSuffix == "png" ||
        urlSuffix == "jpg" ||
        urlSuffix == "jpeg"
      ) {
        window.open(filePath);
      } else {
        window.open(
          "https://view.officeapps.live.com/op/view.aspx?src=" +
            encodeURIComponent(filePath)
        );
      }
    }
  },
  full() {
    console.log("-----------");
    // 判断是否支持
    if (!screenfull.enabled) {
      vueObject.$message({
        message: "不支持全屏",
        type: "warning"
      });
      return false;
    }
    screenfull.toggle();
  },
 

    async getPlayUrl (url) {
      if(!url.includes('.myqcloud.com')){
        return url
      }
      let Bucket= url.split('.cos.')[0]
      let buckets= url.split('.cos.')[1]
      let Region=buckets.split('.myqcloud.com')[0]
      let Regions=buckets.split('.myqcloud.com')[1]
      let Buckets = Bucket.split('https://')[1]
        try {
        var data = await cos.getObjectUrl(
          {
            SecretId: 'AKID5uCLUL3HNhkV2RnBWaN2dAyjFVeap2Ye',
            SecretKey: '6vTJXYEi4D69uPi1Al6BxUJzLPPSErBF',
            Bucket:Buckets , /* 填写自己的 bucket，必须字段 */
            Region:Region,     /* 存储桶所在地域，必须字段 */
            Key: decodeURIComponent(Regions) , /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），支持中文，必须字段 */
            Sign: true,
            Expires: 600,
          },
          function (err, data) {
            if (err) return console.log(err);
            return data.Url
          }
        )
        return data
        } catch (err) {
          
          return { err: err, data: null };
        }
    },
    async getPlayUrls (url) {
      return new Promise((resolve, reject) => {
        if(!url.includes('.myqcloud.com')){
          return url
        }
        let Bucket= url.split('.cos.')[0]
        let buckets= url.split('.cos.')[1]
        let Region=buckets.split('.myqcloud.com')[0]
        let Regions=buckets.split('.myqcloud.com')[1]
        let Buckets = Bucket.split('https://')[1]
     
        cos.getObjectUrl(
            {
              SecretId: 'AKID5uCLUL3HNhkV2RnBWaN2dAyjFVeap2Ye',
              SecretKey: '6vTJXYEi4D69uPi1Al6BxUJzLPPSErBF',
              Bucket:Buckets , /* 填写自己的 bucket，必须字段 */
              Region:Region,     /* 存储桶所在地域，必须字段 */
              Key: decodeURIComponent(Regions) , /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），支持中文，必须字段 */
              Sign: true,
              Expires:600,
            },
            function (err, data) {
              if (err) return console.log(err);
              resolve(data.Url) 
            }
          )
          
      })
      
    },
  
};
